(function () {
    function loadAuth0Script(callback) {
        var script = document.createElement("script");
        script.src = "https://cdn.auth0.com/js/auth0/9.19/auth0.min.js";
        script.async = true;
        script.onload = callback;
        document.head.appendChild(script);
    }

    function getReferralCode() {
        try {
            const tradeAttributeInfo = sessionStorage.getItem('tradeAttributeInfo');
            if (tradeAttributeInfo) {
                const data = JSON.parse(tradeAttributeInfo);
                return data.referralCode?.value || null;
            }
            return null;
        } catch (error) {
            console.error('Error getting referral code:', error);
            return null;
        }
    }

    // 根据域名自动判断站点标识
    function getSiteIdentifier() {
        const hostname = window.location.hostname;
        // 澳洲站点 → SF
        if (hostname.includes('au.yarbo.com')) {
            return 'sf';
        }
        // 测试域名 → SF
        if (hostname.includes('yarbo-dev-store.myshopify.com')) {
            return 'sf';
        }
        // 从 URL 参数获取
        try {
            const urlObj = new URL(window.location.href);
            const siteIdFromUrl = urlObj.searchParams.get("site_id");
            if (siteIdFromUrl) {
                return siteIdFromUrl;
            }
        } catch (e) {
            console.log('获取失败');
        }
        return null;
    }

    window.onload = function () {
        loadAuth0Script(function () {
            if (typeof auth0 === "undefined") {
                console.error("Auth0.js load error");
                return;
            }
            const currentUrl = window.location.href;
            const urlObj = new URL(currentUrl);
            const redirect_uri = urlObj.searchParams.get("redirect_uri") || urlObj.searchParams.get("return_url");
            const referralCode = getReferralCode();
            // 获取站点标识
            const siteId = getSiteIdentifier();
            const baseRedirectUri = redirect_uri ? `https://erp-api.yarbo.ai/api/v1/shopify/login?redirect_uri=${encodeURIComponent(redirect_uri)}` : 'https://erp-api.yarbo.ai/api/v1/shopify/login?redirect_uri=/account';
            let redirectUri = referralCode ? `${baseRedirectUri}&referral_code=${encodeURIComponent(referralCode)}` : baseRedirectUri;
            // 将 site_id 添加到 redirectUri
            if (siteId) {
                redirectUri = `${redirectUri}&site_id=${encodeURIComponent(siteId)}`;
            }

            if (typeof window.auth === "undefined") {
                window.auth = new window.auth0.WebAuth({
                    domain: "auth.yarbo.com",
                    clientID: "JZEfDX1XFM1ydR2g4jmR7Be9r9eSnvjI",
                    redirectUri: redirectUri,
                    responseType: "code",
                    scope: "openid profile email"
                });
            }
            window.auth.authorize({
                prompt: 'login'
            });
        });
    };
})();